import { toast } from "react-toastify";
import { api } from "../../server/request";
import { handleResponse, handleError, handleResponseObj } from "../responseUtil";
import {
  SET_WIFI_INTERFACES_LOADING, GET_WIFI_INTERFACES, GET_ALL_INTERFACES, SET_ALL_INTERFACES_LOADING, GET_ALL_NETWORKS, SET_ALL_NETWORKS_LOADING,
  DELETE_INTERFACE, DELETE_INTERFACE_LOADING, DELETE_LAN, DELETE_LAN_LOADING, DELETE_WIFI, DELETE_WIFI_LOADING, GET_PHYSICAL_INTERFACES, GET_PHYSICAL_INTERFACES_LOADING,
  ADD_WAN_INTERFACE, ADD_WAN_INTERFACE_LOADING, UPDATE_WAN_INTERFACE, UPDATE_WAN_INTERFACE_LOADING, GET_WAN_PROFILES, SET_WAN_PROFILES_LOADING, GET_WAN_PROFILE_DETAILS, SET_WAN_PROFILE_DETAILS_LOADING, GET_UNUSED_WAN_INTERFACES, SET_UNUSED_WAN_INTERFACES_LOADING, DELETE_WAN_PROFILE, DELETE_WAN_PROFILE_LOADING,
  ENABLE_DISABLE_INTERFACE, ENABLE_DISABLE_INTERFACE_LOADING, ENABLE_DISABLE_DHCP_LOADING, ENABLE_DISABLE_DHCP, GET_FILTERED_NETWORKS_LOADING, GET_FILTERED_NETWORKS, GET_FREE_LAN_ACCESS_INTERFACES_LOADING, GET_FREE_LAN_ACCESS_INTERFACES, GET_ROUTER_DIDS, GET_ROUTER_DIDS_LOADING, GET_DEREGISTER_DEVICE_LOADING, GET_DEREGISTER_DEVICE,
  GET_REGISTER_DEVICE, GET_REGISTER_DEVICE_LOADING, GET_DEVICE_DETAILS_LOADING, GET_DEVICE_DETAILS, GET_SEARCH_DIDS_LOADING, GET_SEARCH_DIDS, GET_SWAP_MODE_LOADING, GET_SWAP_MODE, GET_DEVICE_LINK_STATUS_LOADING, GET_DEVICE_LINK_STATUS, GET_LAN_TRUNK_FILTERED_NETWORKS_LOADING, GET_LAN_TRUNK_FILTERED_NETWORKS, SET_OPEN_EDGE_SOFTWARE_UPDATE_LOADING, GET_OPEN_EDGE_SOFTWARE_UPDATE, SET_OPEN_EDGE_SOFTWARE_UPDATE_STATUS_LOADING, GET_OPEN_EDGE_SOFTWARE_UPDATE_STATUS, GET_SAVED_WAN_PROFILE_DATA,
  UPDATE_SYNC_CHECK_STATUS, GET_STATIC_ROUTES_LOADING, GET_STATIC_ROUTES, DELETE_STATIC_ROUTE_LOADING, DELETE_STATIC_ROUTE, GET_ALL_WAN_INTERFACES_FOR_ADV_SETTINGS_LOADING, GET_ALL_WAN_INTERFACES_FOR_ADV_SETTINGS, GET_ENABLE_DISABLE_NO_NAT_LOADING, GET_ENABLE_DISABLE_NO_NAT, GET_LAN_IP_RANGES_LOADING, GET_LAN_IP_RANGES, GET_ALL_PORT_CONFIGS_LOADING, GET_ALL_PORT_CONFIGS, GET_ADD_EDIT_PORT_CONFIG_LOADING, GET_ADD_EDIT_PORT_CONFIG, GET_DELETE_PORT_CONFIG_LOADING, GET_DELETE_PORT_CONFIG,
  GET_DHCP_RESERVATIONS_LOADING, GET_DHCP_RESERVATIONS, GET_DELETE_DHCP_RESERVATION_LOADING, GET_DELETE_DHCP_RESERVATION, GET_ALL_FIREWALL_RULES_LOADING, GET_ALL_FIREWALL_RULES, GET_INTERFACES_FIREWALL_RULES_LOADING, GET_INTERFACES_FIREWALL_RULES, GET_ADD_EDIT_FIREWALL_RULE_LOADING, GET_ADD_EDIT_FIREWALL_RULE, GET_ENABLE_DISABLE_FIREWALL_RULE_LOADING, GET_ENABLE_DISABLE_FIREWALL_RULE, GET_DELETE_FIREWALL_RULE_LOADING, GET_DELETE_FIREWALL_RULE,
  GET_ENABLE_DISABLE_DNS_CASHE_LOADING, GET_ENABLE_DISABLE_DNS_CASHE, GET_LAN_MULTICAST_LOADING, GET_LAN_MULTICAST, GET_SET_LAN_MULTICAST_LOADING, GET_SET_LAN_MULTICAST, GET_DNS_PROXY_CONFIG_LOADING, GET_DNS_PROXY_CONFIG, GET_DELETE_DNS_PROXY_CONFIG_LOADING, GET_DELETE_DNS_PROXY_CONFIG, GET_IP_CONFIG_UPDATE_LOADING, GET_IP_CONFIG_UPDATE, GET_ENABLE_DISABLE_PORT_FORWARD_LOADING, GET_ENABLE_DISABLE_PORT_FORWARD, SET_FIREWALL_RULE_PRIORITY_LOADING,
  GET_IS_AM_AVAILABLE, GET_MODEM_DETAILS, GET_SIM_DETAILS, TRIGGER_TOWER_SCAN, GET_TOWER_SCAN_RESULTS, GET_SIM_PRIORITY_DETAILS, UPDATE_SIM_PRIORITY_DETAILS, RELOAD_SIM_DETAILS, RESET_MODEM, UPDATE_SIM_SETTINGS,
  UPDATE_AM_CONTROLLER_ACTION_STATUS,
  SET_FECTH_MODEM_DETAILS_LOADING,
  GET_IDENTITY_RULES_LOADING,
  GET_IDENTITY_RULES,
  GET_IDENTITY_RULES_BY_ID_LOADING,
  GET_IDENTITY_RULE_BY_ID,
  CREATE_UPDATE_IDENTITY_RULE_LOADING,
  CREATE_UPDATE_IDENTITY_RULE,
  DELETE_IDENTITY_RULE,
  DELETE_IDENTITY_RULE_LOADING,
  FETCH_FIREWALL_PROTOCOLS,
  FETCH_FIREWALL_PROTOCOLS_LOADING,
  GET_ALL_HUB_CLIENTS_LOADING,
  GET_ALL_HUB_CLIENTS,
  SELECT_HUB_CLIENT_LOADING,
  SELECT_HUB_CLIENT,
  GET_HUB_MTD_USAGE_LOADING,
  GET_HUB_MTD_USAGE,
  GET_HUB_SERVER_STATUS_LOADING,
  GET_HUB_SERVER_STATUS,
  GET_ACTIVE_HUB_CLIENT_LOADING,
  GET_ACTIVE_HUB_CLIENT,
  CREATE_PRIVATE_HUB_SERVER_LOADING,
  CREATE_PRIVATE_HUB_SERVER,
  GET_PRIVATE_HUB_SERVERS_LOADING,
  GET_PRIVATE_HUB_SERVERS,
  DELETE_PRIVATE_HUB_SERVER_LOADING,
  DELETE_PRIVATE_HUB_SERVER,
  UPDATE_PRIVATE_HUB_SERVER_LOADING,
  UPDATE_PRIVATE_HUB_SERVER,
} from "../types";

import _ from "lodash";

export const getWifiInterfacesData = (deviceId) => (dispatch) => {
  dispatch({ type: SET_WIFI_INTERFACES_LOADING, payload: true });
  const payload = {
    "DID": deviceId
  }
  api
    .postRequestOut(`/oesb/getWifiInterfaces`, payload)
    .then((res) => handleResponse(res, dispatch, GET_WIFI_INTERFACES))
    .catch((err) => handleError(err, dispatch));
}

export const getAllInterfacesData = (deviceId, interface_type, version) => (dispatch) => {
  dispatch({ type: SET_ALL_INTERFACES_LOADING, payload: true });
  const payload = {
    "DID": deviceId,
    "interface_type": interface_type != 'WIFI' ? interface_type : undefined,
    "type": interface_type == 'WIFI' ? 'wifi_interfaces' : undefined,
    "swVersion": version
  }
  api
    .postRequestOut(`/oesb/getDashboardData`, payload)
    .then((res) => handleResponse(res, dispatch, GET_ALL_INTERFACES))
    .catch((err) => handleError(err, dispatch));
}

export const getAllNetworksData = (deviceId) => (dispatch) => {
  dispatch({ type: SET_ALL_NETWORKS_LOADING, payload: true });
  const payload = {
    "DID": deviceId
  }
  api
    .postRequestOut(`/oesb/getAllNetworks`, payload)
    .then((res) => handleResponse(res, dispatch, GET_ALL_NETWORKS))
    .catch((err) => handleError(err, dispatch));
}

export const deleteInterfaceData = (deviceId, id) => (dispatch) => {
  dispatch({ type: DELETE_INTERFACE_LOADING, payload: true });
  const payload = {
    "DID": deviceId,
    "id": id
  }
  api
    .postRequestOutWithOESync(`/oesb/deleteInterface`, payload, dispatch)
    .then((res) => handleResponse(res, dispatch, DELETE_INTERFACE))
    .catch((err) => handleError(err, dispatch));
}

export const deleteLanData = (deviceId, vlan_id, id) => (dispatch) => {
  dispatch({ type: DELETE_LAN_LOADING, payload: true });
  const payload = {
    "DID": deviceId,
    "vlan_id": vlan_id,
    "id": id
  }
  api
    .postRequestOutWithOESync(`/oesb/deleteNetwork`, payload, dispatch)
    .then((res) => handleResponse(res, dispatch, DELETE_LAN))
    .catch((err) => handleError(err, dispatch));
}

export const deleteWifiData = (deviceId, id) => (dispatch) => {
  dispatch({ type: DELETE_WIFI_LOADING, payload: true });
  const payload = {
    "DID": deviceId,
    "id": id
  }
  api
    .postRequestOutWithOESync(`/oesb/deleteWifiInterface`, payload, dispatch)
    .then((res) => handleResponse(res, dispatch, DELETE_WIFI))
    .catch((err) => handleError(err, dispatch));
}

export const getPhysicalInterfacesData = (deviceId) => (dispatch) => {
  dispatch({ type: GET_PHYSICAL_INTERFACES_LOADING, payload: true });
  const payload = {
    "DID": deviceId,
    "required_fields": ["id", "alias", "device", "primary_interface"],
    "query": [
      { "key": "is_primary", "value": true, "operator": "=" },
      { "key": "interface_type", "value": "WAN", "operator": "="}
    ]
  }
  api
    .postRequestOut(`/oesb/getFilteredInterfaces`, payload)
    .then((res) => handleResponse(res, dispatch, GET_PHYSICAL_INTERFACES))
    .catch((err) => handleError(err, dispatch));
}

export const addWanInterfaceData = (payload, endPoint) => (dispatch) => {
  dispatch({ type: ADD_WAN_INTERFACE_LOADING, payload: true });
  api
    .postRequestOutWithOESync(`/oesb/${endPoint}`, payload, dispatch)
    .then((res) => {
      getToastMessage(res);
      handleResponse(res, dispatch, ADD_WAN_INTERFACE);
    })
    .catch((err) => handleError(err, dispatch));
}

export const updateWanInterfaceData = (payload, endPoint) => (dispatch) => {
  dispatch({ type: UPDATE_WAN_INTERFACE_LOADING, payload: true });
  api
    .postRequestOutWithOESync(`/oesb/${endPoint}`, payload, dispatch)
    .then((res) => {
      getToastMessage(res);
      handleResponse(res, dispatch, UPDATE_WAN_INTERFACE);
    })
    .catch((err) => handleError(err, dispatch));
}

export const enableDisableInterfaceData = (payload, endPoint) => (dispatch) => {
  dispatch({ type: ENABLE_DISABLE_INTERFACE_LOADING, payload: true });
  api
    .postRequestOutWithOESync(`/oesb/${endPoint}`, payload, dispatch)
    .then((res) => handleResponse(res, dispatch, ENABLE_DISABLE_INTERFACE))
    .catch((err) => handleError(err, dispatch));
}

export const enableDisableDHCPData = (payload) => (dispatch) => {
  dispatch({ type: ENABLE_DISABLE_DHCP_LOADING, payload: true });
  api
    .postRequestOut(`/oesb/enableDisableDHCP`, payload)
    .then((res) => handleResponse(res, dispatch, ENABLE_DISABLE_DHCP))
    .catch((err) => handleError(err, dispatch));
}

export const getFilteredNetworksData = (deviceId) => (dispatch) => {
  dispatch({ type: GET_FILTERED_NETWORKS_LOADING, payload: true });
  const payload = {
    "DID": deviceId,
    "required_fields": ["id", "network_alias", "vlan_id", "\"isCaptive\""],
    "query": [
      { "key": "is_mgmt", "value": "false", "operator": "=" }
    ]
  }
  api
    .postRequestOut(`/oesb/getFilteredNetworks`, payload)
    .then((res) => handleResponse(res, dispatch, GET_FILTERED_NETWORKS))
    .catch((err) => handleError(err, dispatch));
}

export const getFreeLanAccessInterfacesData = (deviceId) => (dispatch) => {
  dispatch({ type: GET_FREE_LAN_ACCESS_INTERFACES_LOADING, payload: true });
  const payload = {
    "DID": deviceId
  }
  api
    .postRequestOut(`/oesb/getFreeLANAccessInterfaces`, payload)
    .then((res) => handleResponse(res, dispatch, GET_FREE_LAN_ACCESS_INTERFACES))
    .catch((err) => handleError(err, dispatch));
}

export const getWanProfilesData = (deviceId , isEnabled) => (dispatch) => {
  dispatch({ type: SET_WAN_PROFILES_LOADING, payload: true });

  const payload = isEnabled ? {
    "DID": deviceId,
    "query": [
      { "key": "sys_profile", "value": false, "operator": "=" }
    ]
  } : {
    "DID": deviceId,
  };

  api
    .postRequestOut(`/oesb/getFilteredWANProfiles`, payload)
    .then((res) => handleResponse(res, dispatch, GET_WAN_PROFILES))
    .catch((err) => handleError(err, dispatch));
};

export const getWanProfileDetailsData = (profileId, deviceId) => (dispatch) => {
  dispatch({ type: SET_WAN_PROFILE_DETAILS_LOADING, payload: true });

  const payload = {
    id: profileId,
    "DID": deviceId,
  };

  api
    .postRequestOut(`/oesb/getWANProfileDetails`, payload)
    .then((res) => handleResponse(res, dispatch, GET_WAN_PROFILE_DETAILS))
    .catch((err) => handleError(err, dispatch));
};


export const getUnusedWanInterfacesData = (deviceId, profileId) => async (dispatch) => {
  dispatch({ type: SET_UNUSED_WAN_INTERFACES_LOADING, payload: true });

  const payload = {
    DID: deviceId,
    id: profileId
  };

  try {
    const response = await api.postRequestOut(`/oesb/getAllUnusedWANInterfaces`, payload);
    dispatch({ type: GET_UNUSED_WAN_INTERFACES, payload: response });
    return response;
  } catch (err) {
    handleError(err, dispatch);
    return null;
  }
};

export const updateWanProfileData = (payload) => (dispatch) => {
  console.log("📨 processWANProfile payload:", payload);
  return api
    .postRequestOutWithOESync(`/oesb/processBulkWANProfiles`, payload, dispatch)
    .then((res) => {
      console.log("WAN Profile updated successfully", res);
      dispatch({type: GET_SAVED_WAN_PROFILE_DATA, payload: res})
      return res;
    })
    .catch((err) => {
      handleError(err, dispatch);
      throw err;
    });
};

export const createWanProfileData = (payload) => (dispatch) => {
  return api
    .postRequestOutWithOESync("/oesb/processWANProfile", { data: payload }, dispatch)
    .then((res) => {
      dispatch({type: GET_SAVED_WAN_PROFILE_DATA, payload: res});
      return res;
    })
    .catch((err) => {
      console.error("WAN Create Error:", err);
      return err;
    });
};



export const deleteWanProfileData = (profileId, deviceId) => (dispatch) => {
  dispatch({ type: DELETE_WAN_PROFILE_LOADING, payload: true });

  const payload = {
    id: profileId,
    DID: deviceId,
  };

  return api
    .postRequestOutWithOESync(`/oesb/deleteWANProfile`, payload, dispatch)
    .then((res) => {
      dispatch({ type: DELETE_WAN_PROFILE, payload: res });
      return res;
    })
    .catch((err) => {
      handleError(err, dispatch);
      return null;
    });
};

export const getRouterDidsData = (site_id) => (dispatch) => {
  dispatch({ type: GET_ROUTER_DIDS_LOADING, payload: true });
  const payload = {
    query: 'GET_DEVICES_BY_SITE_ID',
    named: true,
    format: "json",
    parameters: {
      siteIds: site_id ? `'${site_id}'` : '',
      tierAlias: ""
    }
  }
  api
    .postRequestOut(`/store/ch/query`, payload)
    .then((res) => handleResponse(res, dispatch, GET_ROUTER_DIDS))
    .catch((err) => handleError(err, dispatch));
}

export const getRegisterDeviceData = (deviceId, mode, routerDid, siteId) => (dispatch) => {
  dispatch({ type: GET_REGISTER_DEVICE_LOADING, payload: true });
  const payload = {
    data: {
      DID: deviceId,
      mode: mode,
      router_did: mode == 'ap' ? routerDid : undefined,
      site_id: mode == 'router' ? siteId : undefined
    }
  }
  api
    .postRequestOut(`/oesb/registerDevice`, payload)
    .then((res) => {
      getToastMessage(res);
      handleResponse(res, dispatch, GET_REGISTER_DEVICE)
    })
    .catch((err) => handleError(err, dispatch));
}

export const getDeRegisterDeviceData = (deviceId, mode) => (dispatch) => {
  dispatch({ type: GET_DEREGISTER_DEVICE_LOADING, payload: true });
  const payload = {
    data: {
      DID: deviceId,
      mode: mode
    }
  }
  api
    .postRequestOut(`/oesb/deregisterDevice`, payload)
    .then((res) => {
      handleResponse(res, dispatch, GET_DEREGISTER_DEVICE)
    }
    )
    .catch((err) => handleError(err, dispatch));
}

export const getDeviceDeatilsData = (deviceId) => (dispatch) => {
  dispatch({ type: GET_DEVICE_DETAILS_LOADING, payload: true });
  const payload = {
    data: {
      DID: deviceId
    }
  }
  api
    .postRequestOut(`/oesb/getDeviceDetails`, payload)
    .then((res) => {
      handleResponse(res, dispatch, GET_DEVICE_DETAILS)
    }
    )
    .catch((err) => handleError(err, dispatch));
}

export const getSearchDidsData = (deviceIds) => (dispatch) => {
  dispatch({ type: GET_SEARCH_DIDS_LOADING, payload: true });
  const payload = {
    data: {
      dids: deviceIds
    }
  }
  api
    .postRequestOut(`/oesb/searchDIDsv2`, payload)
    .then((res) => {
      handleResponse(res, dispatch, GET_SEARCH_DIDS)
    }
    )
    .catch((err) => handleError(err, dispatch));
}

export const getSwapModeData = (deviceId, mode, router_id) => (dispatch) => {
  dispatch({ type: GET_SWAP_MODE_LOADING, payload: true });
  const payload = {
    data: {
      DID: deviceId,
      mode: mode,
      router_did: mode == 'ap' ? router_id : undefined
    }
  }
  api
    .postRequestOut(`/oesb/swapMode`, payload)
    .then((res) => {
      getToastMessage(res);
      handleResponse(res, dispatch, GET_SWAP_MODE)
    }
    )
    .catch((err) => handleError(err, dispatch));
}

const getToastMessage = (res) => {
  if (res.status == 200 && res?.data?.status == true) {
    toast.success(res?.data?.msg, {
      position: toast.POSITION.BOTTOM_LEFT,
    })
  } else {
    toast.error(res?.data?.msg, {
      position: toast.POSITION.BOTTOM_LEFT,
    })
  }
}

export const getDeviceLinkStatusData = (siteId, deviceId) => (dispatch) => {
    dispatch({ type: GET_DEVICE_LINK_STATUS_LOADING, payload: true });
    api.siteController
        .getRequest(`/v1/sites/${siteId}/devices/${deviceId}/openEdgeSync/interfaces`)
        .then((res) => handleResponseObj(res, dispatch, GET_DEVICE_LINK_STATUS))
        .catch((err) => handleError(err, dispatch));
}

export const getOpenEdgeSOftwareUpdateData = () => (dispatch) => {
  dispatch({ type: SET_OPEN_EDGE_SOFTWARE_UPDATE_LOADING, payload: true });
  const payload = {
    data: {
      action: "download"
    }
  }
  api
    .postRequestOut(`/luci-static/resources/kognitive_package/controllers/downloadFirmware.lua`, payload)
    .then((res) => {
      getToastMessage(res);
      handleResponse(res, dispatch, GET_OPEN_EDGE_SOFTWARE_UPDATE)
    })
    .catch((err) => handleError(err, dispatch));
}

export const getOpenEdgeSOftwareUpdateStatusData = (siteId, deviceId) => (dispatch) => {
  dispatch({ type: SET_OPEN_EDGE_SOFTWARE_UPDATE_STATUS_LOADING, payload: true });
  const payload = {
    query: `GET_SW_UPGRADE_INPROGRESS_INFO`,
    named: true,
    format: 'json',
    parameters: {
      siteId: siteId,
      deviceId: deviceId
    }
  }
  api
    .postRequestOut(`/store/pg/query`, payload)
    .then((res) => handleResponse(res, dispatch, GET_OPEN_EDGE_SOFTWARE_UPDATE_STATUS))
    .catch((err) => handleError(err, dispatch));
}

export const getFilteredLanTrunkNetworksData = (deviceId, linkType) => (dispatch) => {
  dispatch({ type: GET_LAN_TRUNK_FILTERED_NETWORKS_LOADING, payload: true });
  const payload = linkType !== "LAN Access" ? {
    "DID": deviceId,
    "required_fields": ["id", "vlan_id", "network_alias"],
    "query": [
      { "key": "link_type", "value": "LAN Trunk", "operator": "=" },
    ] 
  } : {
    "DID": deviceId,
    "required_fields": ["id", "vlan_id", "network_alias"],
    "query": [
      { "key": "link_type", "value": "LAN Trunk", "operator": "=" },
      { "key": "is_mgmt", "value": "false", "operator": "=" }
    ] 
  }
  api
    .postRequestOut(`/oesb/getFilteredNetworks`, payload)
    .then((res) => handleResponse(res, dispatch, GET_LAN_TRUNK_FILTERED_NETWORKS))
    .catch((err) => handleError(err, dispatch));
}

export const getOESyncStatusData = (deviceId) => (dispatch) => {
  const payload = {
    DID: deviceId
  }
  api
    .postRequestOut(`/oesb/checkPendingconfig`, payload)
    .then((res) => handleResponseObj(res, dispatch, UPDATE_SYNC_CHECK_STATUS))
    .catch((err) => handleError(err, dispatch));
}

export const getStaticRoutesData = (deviceId) => (dispatch) => {
  dispatch({ type: GET_STATIC_ROUTES_LOADING, payload: true });
  const payload = {
    DID: deviceId
  }
  api
  .postRequestOut(`/oesb/getRoutes`, payload)
  .then((res) => handleResponse(res, dispatch, GET_STATIC_ROUTES))
  .catch((err) => handleError(err, dispatch));
}

export const deleteStaticRouteData = (k4Id, deviceId, id) => (dispatch) => {
  dispatch({ type: DELETE_STATIC_ROUTE_LOADING, payload: true });
  const payload = {
    id: id,
    k4Id: k4Id,
    DID: deviceId,
    source: 'OE'
}
  api
  .postRequestOutWithOESync(`/oesb/deleteRoute`, payload, dispatch)
  .then((res) => handleResponse(res, dispatch, DELETE_STATIC_ROUTE))
  .catch((err) => handleError(err, dispatch));
}

export const geteAllWanInterfacesForAdvSettingsData = (deviceId) => (dispatch) => {
  dispatch({ type: GET_ALL_WAN_INTERFACES_FOR_ADV_SETTINGS_LOADING, payload: true });
  const payload = {
    DID: deviceId
  }
  api
  .postRequestOut(`/oesb/getAllWANInterfacesForAdvSetting`, payload)
  .then((res) => handleResponse(res, dispatch, GET_ALL_WAN_INTERFACES_FOR_ADV_SETTINGS))
  .catch((err) => handleError(err, dispatch));
}

export const getEnableDisableNoNatData = (payload) => (dispatch) => {
  dispatch({ type: GET_ENABLE_DISABLE_NO_NAT_LOADING, payload: true });
  api
  .postRequestOutWithOESync(`/oesb/enableDisableGenericNoNAT`, payload, dispatch)
  .then((res) => {
    getToastMessage(res);
    handleResponse(res, dispatch, GET_ENABLE_DISABLE_NO_NAT)
  })
  .catch((err) => handleError(err, dispatch));
}

export const getLanIpRangesData = (deviceId) => (dispatch) => {
  dispatch({ type: GET_LAN_IP_RANGES_LOADING, payload: true });
  const payload = {
    DID: deviceId
  }
  api
  .postRequestOut(`/oesb/getNetworkAddresses`, payload)
  .then((res) => handleResponse(res, dispatch, GET_LAN_IP_RANGES))
  .catch((err) => handleError(err, dispatch));
}

export const getAllPortConfigsData = (deviceId) => (dispatch) => {
  dispatch({ type: GET_ALL_PORT_CONFIGS_LOADING, payload: true });
  const payload = {
    DID: deviceId
  }
  api
  .postRequestOut(`/oesb/getAllPortConfigs`, payload)
  .then((res) => handleResponse(res, dispatch, GET_ALL_PORT_CONFIGS))
  .catch((err) => handleError(err, dispatch));
}

export const getAddEditPortConfigData = (payload, endPoint) => (dispatch) => {
  dispatch({ type: GET_ADD_EDIT_PORT_CONFIG_LOADING, payload: true });
  api
  .postRequestOutWithOESync(`/oesb/${endPoint}`, payload, dispatch)
  .then((res) => {
    getToastMessage(res);
    handleResponse(res, dispatch, GET_ADD_EDIT_PORT_CONFIG);
  })
  .catch((err) => handleError(err, dispatch));
}

export const getDeletePortConfigData = (deviceId, id) => (dispatch) => {
  dispatch({ type: GET_DELETE_PORT_CONFIG_LOADING, payload: true });
  const payload = {
    id: id,
    DID: deviceId
  }
  api
  .postRequestOutWithOESync(`/oesb/deletePortConfig`, payload, dispatch)
  .then((res) => {
    getToastMessage(res);
    handleResponse(res, dispatch, GET_DELETE_PORT_CONFIG);
  })
  .catch((err) => handleError(err, dispatch));
}

export const getDhcpReservationsData = (deviceId) => (dispatch) => {
  dispatch({ type: GET_DHCP_RESERVATIONS_LOADING, payload: true });
  const payload = {
    DID: deviceId
  }
  api
  .postRequestOut(`/oesb/getReservations`, payload)
  .then((res) => handleResponse(res, dispatch, GET_DHCP_RESERVATIONS))
  .catch((err) => handleError(err, dispatch));
}

export const getDeleteDhcpReservationData = (deviceId, id) => (dispatch) => {
  dispatch({ type: GET_DELETE_DHCP_RESERVATION_LOADING, payload: true });
  const payload = {
    DID: deviceId,
    id: id
  }
  api
  .postRequestOutWithOESync(`/oesb/deleteReservation`, payload, dispatch)
  .then((res) => handleResponse(res, dispatch, GET_DELETE_DHCP_RESERVATION))
  .catch((err) => handleError(err, dispatch));
}

export const getAllFirewallRulesData = (deviceId, type) => (dispatch) => {
  dispatch({ type: GET_ALL_FIREWALL_RULES_LOADING, payload: true });
  const payload = {
    DID: deviceId,
    rule_type: type
  }
  api
  .postRequestOut(`/oesb/getAllFirewallRules`, payload)
  .then((res) => handleResponse(res, dispatch, GET_ALL_FIREWALL_RULES))
  .catch((err) => handleError(err, dispatch));
}

export const getInterfacesFirewallRulesData = (deviceId) => (dispatch) => {
  dispatch({ type: GET_INTERFACES_FIREWALL_RULES_LOADING, payload: true });
  const payload = {
    DID: deviceId
  }
  api
  .postRequestOut(`/oesb/getInterfacesForFirewall`, payload)
  .then((res) => handleResponse(res, dispatch, GET_INTERFACES_FIREWALL_RULES))
  .catch((err) => handleError(err, dispatch));
}

export const getAddEditFirewallRuleData = (payload, endPoint) => (dispatch) => {
  dispatch({ type: GET_ADD_EDIT_FIREWALL_RULE_LOADING, payload: true });
  api
  .postRequestOutWithOESync(`/oesb/${endPoint}`, payload, dispatch)
  .then((res) => {
    getToastMessage(res);
    handleResponse(res, dispatch, GET_ADD_EDIT_FIREWALL_RULE)
  })
  .catch((err) => handleError(err, dispatch));
}

export const getEnableDisableFirewallRuleData = (payload) => (dispatch) => {
  dispatch({ type: GET_ENABLE_DISABLE_FIREWALL_RULE_LOADING, payload: true });
  api
  .postRequestOutWithOESync(`/oesb/enabledisbaleFirewall`, payload, dispatch)
  .then((res) => {
    getToastMessage(res);
    handleResponse(res, dispatch, GET_ENABLE_DISABLE_FIREWALL_RULE)
  })
  .catch((err) => handleError(err, dispatch));
}

export const getEnableDisablePortForwardData = (payload) => (dispatch) => {
  dispatch({ type: GET_ENABLE_DISABLE_PORT_FORWARD_LOADING, payload: true });
  api
  .postRequestOutWithOESync(`/oesb/enableDisablePortConfig`, payload, dispatch)
  .then((res) => {
    getToastMessage(res);
    handleResponse(res, dispatch, GET_ENABLE_DISABLE_PORT_FORWARD)
  })
  .catch((err) => handleError(err, dispatch));
}

export const getDeleteFirewallRuleData = (deviceId, id, rule_type) => (dispatch) => {
  dispatch({ type: GET_DELETE_FIREWALL_RULE_LOADING, payload: true });
  const payload = {
    DID: deviceId,
    id: id,
    rule_type: rule_type
  }
  api
  .postRequestOutWithOESync(`/oesb/deleteFirewall`, payload, dispatch)
  .then((res) => {
    getToastMessage(res);
    handleResponse(res, dispatch, GET_DELETE_FIREWALL_RULE)
  })
  .catch((err) => handleError(err, dispatch));
}

export const getEnableDisableDnsProxyData = (payload) => (dispatch) => {
  dispatch({ type: GET_ENABLE_DISABLE_DNS_CASHE_LOADING, payload: true });
  api
  .postRequestOutWithOESync(`/oesb/dnsCacheEnabled`, payload, dispatch)
  .then((res) => {
    getToastMessage(res);
    handleResponse(res, dispatch, GET_ENABLE_DISABLE_DNS_CASHE)
  })
  .catch((err) => handleError(err, dispatch));
}

export const getLanMulticastData = (deviceId) => (dispatch) => {
  dispatch({ type: GET_LAN_MULTICAST_LOADING, payload: true });
  const payload = {
    DID: deviceId
  }
  api
  .postRequestOut(`/oesb/getLANMulticast`, payload)
  .then((res) => handleResponse(res, dispatch, GET_LAN_MULTICAST))
  .catch((err) => handleError(err, dispatch));
}

export const getSetLanMulticastData = (payload) => (dispatch) => {
  dispatch({ type: GET_SET_LAN_MULTICAST_LOADING, payload: true });
  api
  .postRequestOutWithOESync(`/oesb/setLANMulticast`, payload, dispatch)
  .then((res) => {
    getToastMessage(res);
    handleResponse(res, dispatch, GET_SET_LAN_MULTICAST);
  })
  .catch((err) => handleError(err, dispatch));
}

export const getDnsProxyConfigData = (deviceId) => (dispatch) => {
  dispatch({ type: GET_DNS_PROXY_CONFIG_LOADING, payload: true });
  const payload = {
    DID: deviceId
  }
  api
  .postRequestOut(`/oesb/getDNSProxyConfig`, payload)
  .then((res) => handleResponse(res, dispatch, GET_DNS_PROXY_CONFIG))
  .catch((err) => handleError(err, dispatch));
}

export const getDeleteDnsProxyConfigData = (endPoint, deviceId, id) => (dispatch) => {
  dispatch({ type: GET_DELETE_DNS_PROXY_CONFIG_LOADING, payload: true });
  const payload = {
    DID: deviceId,
    id: id
  }
  api
  .postRequestOutWithOESync(`/oesb/${endPoint}`, payload, dispatch)
  .then((res) => {
    getToastMessage(res);
    handleResponse(res, dispatch, GET_DELETE_DNS_PROXY_CONFIG);
  })
  .catch((err) => handleError(err, dispatch));
}

export const getIpConfigUpdateData = (payload) => (dispatch) => {
  dispatch({ type: GET_IP_CONFIG_UPDATE_LOADING, payload: true });
  api
  .postRequestOut(`/oesb/enableDisableGenericDHCP`, payload)
  .then((res) => {
    getToastMessage(res);
    handleResponse(res, dispatch, GET_IP_CONFIG_UPDATE);
  })
  .catch((err) => handleError(err, dispatch));
}

export const updateFirewallPriorityAPI = (deviceId, row, newOrder, rule_type) => (dispatch) => {
  dispatch({ type: SET_FIREWALL_RULE_PRIORITY_LOADING, payload: true });
  const payload = {
    DID: deviceId,
    id: row.id,
    priority: newOrder,
    rule_type: rule_type
  };

  return api
    .postRequestOutWithOESync('/oesb/updateFirewallPriority', payload, dispatch)
    .then((res) => {
      dispatch({ type: SET_FIREWALL_RULE_PRIORITY_LOADING, payload: false });
      getToastMessage(res);
      return res;
    })
    .catch((err) => {
      // Optionally dispatch an error action here
      throw err;
    });
};

//Identity Rules
export const getIdentityRuleList = (deviceId) => (dispatch) => {
  dispatch({ type: GET_IDENTITY_RULES_LOADING, payload: true });
  const payload = {
    DID: deviceId,
  }
  api
  .postRequestOut(`/oesb/getRulesList`, payload)
  .then((res) => handleResponse(res, dispatch, GET_IDENTITY_RULES))
  .catch((err) => handleError(err, dispatch));
}

export const getIdentityRuleById = (deviceId, ruleId) => (dispatch) => {
  dispatch({ type: GET_IDENTITY_RULES_BY_ID_LOADING, payload: true });
  const payload = {
    DID: deviceId,
    id: ruleId
  }
  api
  .postRequestOut(`/oesb/getRuleDetails`, payload)
  .then((res) => handleResponse(res, dispatch, GET_IDENTITY_RULE_BY_ID))
  .catch((err) => handleError(err, dispatch));
}

export const addEditIdentityRule = (payload) => (dispatch) => {
  dispatch({ type: CREATE_UPDATE_IDENTITY_RULE_LOADING, payload: true });
  api
  .postRequestOutWithOESync(`/oesb/processIdentityRule`, payload, dispatch)
  .then((res) => {
    getToastMessage(res);
    handleResponse(res, dispatch, CREATE_UPDATE_IDENTITY_RULE)
  })
  .catch((err) => handleError(err, dispatch));
} 

export const deleteIdentityRule = (id, deviceId, userName, k4Id) => (dispatch) => {
  dispatch({ type: DELETE_IDENTITY_RULE_LOADING, payload: true });
  const payload = {
    id : id,
    DID: deviceId,
    userName: userName,
    k4Id: k4Id,
  }
  api
  .postRequestOutWithOESync(`/oesb/deleteIdentityRule`, payload, dispatch)
  .then((res) => {
    getToastMessage(res);
    handleResponse(res, dispatch, DELETE_IDENTITY_RULE);
  })
  .catch((err) => handleError(err, dispatch));
}


//AM Controller Actions
export const triggerAMControllerAction = (siteId, deviceId, payload) => (dispatch) => {
  console.log("Triggering AM Controller Action with payload:", siteId, deviceId, payload);
  api
    .postRequestOut(`/client/v1/sites/${siteId}/devices/${deviceId}/openEdge/amcontroller/actions`, payload)
    .then((res) => handleResponseObj(res, dispatch, UPDATE_AM_CONTROLLER_ACTION_STATUS))
    .catch((err) => handleError(err, dispatch));
}

export const getAMavailibility = (siteId, deviceId, payload) => (dispatch) => {
  let payloadObj = {
    action: "isAMAvailable",
    payload: payload
  };
  api
    .postRequestOut(`/client/v1/sites/${siteId}/devices/${deviceId}/openEdge/amcontroller/actions`, payloadObj)
    .then((res) => handleResponseObj(res, dispatch, GET_IS_AM_AVAILABLE))
    .catch((err) => handleError(err, dispatch));
}

export const getAMdetails = (siteId, deviceId, payload) => (dispatch) => {
  dispatch({ type: SET_FECTH_MODEM_DETAILS_LOADING, payload: true });

  let payloadObj = {
    action: "getAMDetails",
    payload: payload
  };
  api
    .postRequestOut(`/client/v1/sites/${siteId}/devices/${deviceId}/openEdge/amcontroller/actions`, payloadObj)
    .then((res) => handleResponseObj(res, dispatch, GET_MODEM_DETAILS))
    .catch((err) => {
      dispatch({ type: GET_MODEM_DETAILS, payload: {} });
      handleError(err, dispatch);
    });
}

export const getSimDetails = (siteId, deviceId, payload) => (dispatch) => {
  let payloadObj = {
    action: "getSimDetails",
    payload: payload
  };
  api
    .postRequestOut(`/client/v1/sites/${siteId}/devices/${deviceId}/openEdge/amcontroller/actions`, payloadObj)
    .then((res) => handleResponseObj(res, dispatch, GET_SIM_DETAILS))
    .catch((err) => {
      dispatch({ type: GET_SIM_DETAILS, payload: {} });
      handleError(err, dispatch);
    });
}

export const triggerTowerScan = (siteId, deviceId, payload) => (dispatch) => {
  let payloadObj = {
    action: "triggerTowerScan",
    payload: payload
  };
  api
    .postRequestOut(`/client/v1/sites/${siteId}/devices/${deviceId}/openEdge/amcontroller/actions`, payloadObj)
    .then((res) => handleResponseObj(res, dispatch, TRIGGER_TOWER_SCAN))
    .catch((err) => handleError(err, dispatch));
}

export const getTowerScanResult = (siteId, deviceId, payload) => (dispatch) => {
  let payloadObj = {
    action: "getTowerScanResult",
    payload: payload
  };
  api
    .postRequestOut(`/client/v1/sites/${siteId}/devices/${deviceId}/openEdge/amcontroller/actions`, payloadObj)
    .then((res) => handleResponseObj(res, dispatch, GET_TOWER_SCAN_RESULTS))
    .catch((err) => handleError(err, dispatch));
}

export const getSimPriorityDetails = (siteId, deviceId, payload) => (dispatch) => {
  let payloadObj = {
    action: "getPriorityDetails",
    payload: payload
  };
  api
    .postRequestOut(`/client/v1/sites/${siteId}/devices/${deviceId}/openEdge/amcontroller/actions`, payloadObj)
    .then((res) => handleResponseObj(res, dispatch, GET_SIM_PRIORITY_DETAILS))
    .catch((err) => handleError(err, dispatch));
}

export const updateSimPriority = (siteId, deviceId, payload) => (dispatch) => {
  let payloadObj = {
    action: "updateSimPriority",
    payload: payload
  };
  api
    .postRequestOut(`/client/v1/sites/${siteId}/devices/${deviceId}/openEdge/amcontroller/actions`, payloadObj)
    .then((res) => handleResponseObj(res, dispatch, UPDATE_SIM_PRIORITY_DETAILS))
    .catch((err) => handleError(err, dispatch));
}

export const reloadSimDetails = (siteId, deviceId, payload) => (dispatch) => {
  let payloadObj = {
    action: "reloadSimDetails",
    payload: payload
  };
  api
    .postRequestOut(`/client/v1/sites/${siteId}/devices/${deviceId}/openEdge/amcontroller/actions`, payloadObj)
    .then((res) => handleResponseObj(res, dispatch, RELOAD_SIM_DETAILS))
    .catch((err) => handleError(err, dispatch));
}

export const resetModem = (siteId, deviceId, payload) => (dispatch) => {
  let payloadObj = {
    action: "resetModem",
    payload: payload
  };
  api
    .postRequestOut(`/client/v1/sites/${siteId}/devices/${deviceId}/openEdge/amcontroller/actions`, payloadObj)
    .then((res) => handleResponseObj(res, dispatch, RESET_MODEM))
    .catch((err) => handleError(err, dispatch));
}

export const updateSimDetails = (siteId, deviceId, payload) => (dispatch) => {
  let payloadObj = {
    action: "updateSimDetails",
    payload: payload
  };
  api
    .postRequestOut(`/client/v1/sites/${siteId}/devices/${deviceId}/openEdge/amcontroller/actions`, payloadObj)
    .then((res) => handleResponseObj(res, dispatch, UPDATE_SIM_SETTINGS))
    .catch((err) => handleError(err, dispatch));
}

export const geFirewallProtocolList = () => (dispatch) => {
    dispatch({ type: FETCH_FIREWALL_PROTOCOLS_LOADING, payload: true });
    api
    .postRequestOut(`/oesb/getFirewallProtcols`)
    .then((res) => handleResponseObj(res, dispatch, FETCH_FIREWALL_PROTOCOLS))
    .catch((err) => handleError(err, dispatch));
}

export const getAllHubClientsData = () => (dispatch) => {
  dispatch({ type: GET_ALL_HUB_CLIENTS_LOADING, payload: true });
  api.siteController
    .get('/v1/sites/hub_internet_dropoff')
    .then((res) => dispatch({ type: GET_ALL_HUB_CLIENTS, payload: res }))
    .catch((err) => handleError(err, dispatch));
}

export const selectHubClientData = (did: string, name: string, hub_ips: string, password: string, userName: string, k4Id: string, type: string) => (dispatch) => {
  dispatch({ type: SELECT_HUB_CLIENT_LOADING, payload: true });
  const payload = { data: { DID: did, name, hub_ips, password, userName, k4Id, type } };
  api
    .postRequestOutWithOESync(`/oesb/assignHUBClient`, payload, dispatch)
    .then((res) => handleResponse(res, dispatch, SELECT_HUB_CLIENT))
    .catch((err) => handleError(err, dispatch));
}

export const getHubServerStatusData = (siteId: string, deviceId: string) => (dispatch) => {
  dispatch({ type: GET_HUB_SERVER_STATUS_LOADING, payload: true });
  api.siteController
    .get(`/v1/sites/${siteId}/devices/${deviceId}/hubServer`)
    .then((res) => dispatch({ type: GET_HUB_SERVER_STATUS, payload: res }))
    .catch((err) => {
      dispatch({ type: GET_HUB_SERVER_STATUS, payload: {} });
      handleError(err, dispatch);
    });
}

export const getActiveHubClientData = (deviceId: string) => (dispatch) => {
  dispatch({ type: GET_ACTIVE_HUB_CLIENT_LOADING, payload: true });
  const payload = { DID: deviceId };
  api
    .postRequestOut(`/oesb/getActiveHubClient`, payload)
    .then((res) => handleResponse(res, dispatch, GET_ACTIVE_HUB_CLIENT))
    .catch((err) => handleError(err, dispatch));
}

export const createPrivateHubServerData = (deviceId: string, name: string, hub_ips: string, password: string = "") => (dispatch) => {
  dispatch({ type: CREATE_PRIVATE_HUB_SERVER_LOADING, payload: true });
  const payload = { data: { DID: deviceId, name, hub_ips, password } };
  api
    .postRequestOutWithOESync(`/oesb/createPrivateHubServer`, payload, dispatch)
    .then((res) => handleResponse(res, dispatch, CREATE_PRIVATE_HUB_SERVER))
    .catch((err) => handleError(err, dispatch));
}

export const updatePrivateHubServerData = (id: string, deviceId: string, name: string, hub_ips: string, password: string = "") => (dispatch) => {
  dispatch({ type: UPDATE_PRIVATE_HUB_SERVER_LOADING, payload: true });
  const payload = { data: { id, DID: deviceId, name, hub_ips, password } };
  api
    .postRequestOutWithOESync(`/oesb/updatePrivateHubServer`, payload, dispatch)
    .then((res) => handleResponse(res, dispatch, UPDATE_PRIVATE_HUB_SERVER))
    .catch((err) => handleError(err, dispatch));
}

export const getPrivateHubServersData = (deviceId: string) => (dispatch) => {
  dispatch({ type: GET_PRIVATE_HUB_SERVERS_LOADING, payload: true });
  const payload = { DID: deviceId };
  api
    .postRequestOut(`/oesb/getPrivateHubServers`, payload)
    .then((res) => handleResponse(res, dispatch, GET_PRIVATE_HUB_SERVERS))
    .catch((err) => handleError(err, dispatch));
}

export const deletePrivateHubServerData = (id: string, deviceId: string) => (dispatch) => {
  dispatch({ type: DELETE_PRIVATE_HUB_SERVER_LOADING, payload: true });
  const payload = { id, DID: deviceId };
  api
    .postRequestOutWithOESync(`/oesb/deletePrivateHubServer`, payload, dispatch)
    .then((res) => handleResponse(res, dispatch, DELETE_PRIVATE_HUB_SERVER))
    .catch((err) => handleError(err, dispatch));
}

export const getHubMtdUsageData = (locationId: string, deviceId: string, dateRegistered?: string) => (dispatch) => {
  dispatch({ type: GET_HUB_MTD_USAGE_LOADING, payload: true });
  const now = new Date();
  const pad = (n: number) => String(n).padStart(2, '0');
  const firstOfMonth = new Date(Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), 1));
  const regDate = dateRegistered ? new Date(dateRegistered) : null;
  const useRegDate = regDate && !isNaN(regDate.getTime()) && regDate > firstOfMonth;
  const startTime = useRegDate
    ? `${regDate!.getUTCFullYear()}-${pad(regDate!.getUTCMonth() + 1)}-${pad(regDate!.getUTCDate())} ${pad(regDate!.getUTCHours())}:${pad(regDate!.getUTCMinutes())}:${pad(regDate!.getUTCSeconds())}`
    : `${now.getUTCFullYear()}-${pad(now.getUTCMonth() + 1)}-01 00:00:00`;
  const endTime = `${now.getUTCFullYear()}-${pad(now.getUTCMonth() + 1)}-${pad(now.getUTCDate())} ${pad(now.getUTCHours())}:${pad(now.getUTCMinutes())}:${pad(now.getUTCSeconds())}`;
  const payload = {
    query: 'OE_MPK_USAGE_API',
    named: true,
    format: 'json',
    parameters: { location_id: locationId, device_id: deviceId, start_time: startTime, end_time: endTime },
  };
  api
    .postRequestOut('/store/ch/query', payload)
    .then((res) => handleResponse(res, dispatch, GET_HUB_MTD_USAGE))
    .catch((err) => handleError(err, dispatch));
}